import {
  type FavoriteVehicle,
  RequestedFeature
} from '@carvana/merch-contracts';

export type FavoritesSearchAnalytics = {
  browser: string;
  clientId: string;
  deviceName: string;
  isMobileDevice: boolean;
  referrer: string;
};

const sortBy: 'MostPopular' = 'MostPopular';

const commonRequestedFeatures = [
  RequestedFeature.FetchTradeIn,
  RequestedFeature.LoanTermPricing
];

export default function buildFavoritesSearchRequest({
  analyticsData,
  browserCookieId,
  favoriteVehicles,
  hasAppliedTrade,
  preferredTrade,
  zip
}: {
  analyticsData: FavoritesSearchAnalytics;
  browserCookieId: string;
  favoriteVehicles: FavoriteVehicle[];
  hasAppliedTrade?: boolean;
  preferredTrade?: string;
  zip: string;
}) {
  return {
    analyticsData,
    browserCookieId,
    filters: { vehicleIds: favoriteVehicles.map(v => v.vehicleId) },
    pagination: { page: 1, pageSize: 50 },
    preferredAcquisitionName: hasAppliedTrade ? preferredTrade : undefined,
    requestedFeatures: hasAppliedTrade
      ? [...commonRequestedFeatures, RequestedFeature.ApplyTradeIn]
      : commonRequestedFeatures,
    sortBy,
    zip5: zip
  };
}
